import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: require('@/page/Main').default
    },
    {
      path: '/contact',
      name: 'Contact',
      component: require('@/page/Contact').default
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js